import { Dictionary } from '../../Application';
var CommandFactory = (function () {
    function CommandFactory() {
        this.factories = new Dictionary();
    }
    CommandFactory.prototype.create = function (args) {
        var constructor = this.factories.value(this.getId(args));
        if (!constructor) {
            return null;
        }
        return new constructor(args.parameters || args.Parameters || args);
    };
    CommandFactory.prototype.getId = function (args) {
        return args.id || args.Id || (args.parameters ? args.parameters.id : undefined) ||
            (args.Parameters ? args.Parameters.Id : undefined);
    };
    CommandFactory.prototype.register = function (name, constructor) {
        this.factories.add(name, constructor);
    };
    return CommandFactory;
}());
export { CommandFactory };
